import { useMutation, useQueryClient } from 'react-query'

import { OptimizationProcess } from '../../../types'
import { post } from '../../../utils/api'
import { handleApiErrors } from '../../../utils/apiErrors'

export const useAbortOptimizationProcess = () => {
  const queryClient = useQueryClient()
  return useMutation(
    [`optimization-processes`, `abort`],
    (optimizationProcessId: number) =>
      post<OptimizationProcess>(
        `/optimization-processes/${optimizationProcessId}/abort/`,
        {}
      ),
    {
      onError: handleApiErrors,
      onSuccess: () => {
        // instead of manually modifying query data, we invalidate the query
        // and let the refetch magic happen, for reference, we leave below an
        // example implementation of manual data edit
        queryClient.invalidateQueries(['optimization-processes'])
      },
      // onSuccess: (
      //   newData: OptimizationProcess,
      //   optimizationProcessId: number
      // ) => {
      //   queryClient.setQueryData<
      //     InfiniteData<OptimizationProcesses> | undefined
      //   >('optimization-processes', (data) =>
      //     data
      //       ? {
      //           pageParams: data.pageParams,
      //           pages: data.pages.map((page) => ({
      //             ...page,
      //             results: page.results.map((optimizationProcess) =>
      //               optimizationProcess.id === optimizationProcessId
      //                 ? newData
      //                 : optimizationProcess
      //             ),
      //           })),
      //         }
      //       : undefined
      //   )
      // },
    }
  )
}
